<template>
  <h3 v-if="payouts.length === 0">No Payouts</H3>
  <div v-else>
    <div class="mb-3">
      <DataTable :value="payouts" 
        class="p-datatable-sm"
        breakpoint="992px" 
        responsiveLayout="stack"
        id="payout-table"
        stripedRows>
        <Column field="date" header="Date">
          <template #body="slotProps">
            {{ moment(slotProps.data.date).format('M/D/YY h:mm A') }}
          </template>
        </Column>
        <Column field="status" header="Status"></Column>
        <Column field="amount" header="Amount">
          <template #body="slotProps">
            {{ formatDollars(slotProps.data.amount) }}
          </template>
        </Column>
        <Column field="date_arrive" header="Available On">
          <template #body="slotProps">
            {{ moment(slotProps.data.date_arrive).format('M/D/YY h:mm A') }}
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    props: {
      payouts: Array,
    },
    created() {
      this.moment = moment
    }
  }
</script>
